/**
 * Description placeholder
 *
 * @export
 * @param {boolean} canEdit
 * @param {any} selectedFile
 * @param {string} alias
 * @param {number} maxFileSize
 * @param {Array} resources
 * @returns {{ valid: boolean; error: string; warnToast: boolean; }}
 */
export function validateBeforeFileUpload(canEdit, selectedFile, alias, maxFileSize, resources) {
    if (!canEdit) return { valid: false, error: null, warnToast: false };

    if (!selectedFile) {
        return {
            valid: false,
            error: "Please choose a file to upload",
            warnToast: true
        };
    }

    if (!alias) {
        return {
            valid: false,
            error: "Please enter a file description",
            warnToast: true
        };
    }

    if (selectedFile.size > maxFileSize) {
        return {
            valid: false,
            error: "File size exceeds allowed limit. Please select a smaller file.",
            warnToast: false
        };
    }

    const containsDuplicateName = resources.some((resource) => {
        return selectedFile.name === resource.uri.split("/").pop();
    });

    if (containsDuplicateName) {
        return {
            valid: false,
            error: "A resource with that filename already exists. Please enter a unique filename. ",
            warnToast: false
        };
    }

    const containsDuplicateAlias = resources.some((resource) => {
        return alias === resource.alias;
    });

    if (containsDuplicateAlias) {
        return {
            valid: false,
            error: "A resource with that alias already exists. Please enter a unique alias. ",
            warnToast: false
        };
    }

    return { valid: true, error: null, warnToast: false };
}
